import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  // Main page styling
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "#2c3e50",
    backgroundColor: "#ffffff",
    lineHeight: 1.4,
  },

  // Header section with gradient-like effect
  header: {
    marginBottom: 30,
    paddingBottom: 20,
    borderBottomWidth: 3,
    borderBottomColor: "#3498db",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  invoiceNumber: {
    fontSize: 14,
    color: "#3498db",
    fontWeight: "bold",
    textAlign: "right",
    backgroundColor: "#ecf0f1",
    padding: 8,
    borderRadius: 4,
  },
  date: {
    fontSize: 11,
    color: "#7f8c8d",
    textAlign: "right",
    marginTop: 4,
  },

  // Company information sections
  twoColumns: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 25,
    gap: 20,
  },
  column: {
    width: "48%",
    backgroundColor: "#f8f9fa",
    padding: 15,
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: "#3498db",
  },
  receiverColumn: {
    width: "48%",
    backgroundColor: "#f8f9fa",
    padding: 15,
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: "#e74c3c",
  },
  sectionTitle: {
    fontSize: 13,
    marginBottom: 8,
    fontWeight: "bold",
    color: "#2c3e50",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },

  // Custom fields section
  customFieldsSection: {
    marginBottom: 25,
    backgroundColor: "#fff3cd",
    padding: 15,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#ffeaa7",
  },

  // Table styling
  detailTable: {
    borderWidth: 1,
    borderColor: "#bdc3c7",
    marginBottom: 25,
    borderRadius: 8,
    overflow: "hidden",
  },
  tableRowHeader: {
    flexDirection: "row",
    backgroundColor: "#34495e",
    color: "white",
    padding: 12,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ecf0f1",
    padding: 10,
    backgroundColor: "#ffffff",
  },
  tableRowAlternate: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ecf0f1",
    padding: 10,
    backgroundColor: "#f8f9fa",
  },
  cell: {
    flex: 1,
    paddingRight: 8,
    fontSize: 9,
  },
  cellDescription: {
    flex: 2,
    paddingRight: 8,
    fontSize: 9,
  },
  cellNumber: {
    flex: 1,
    paddingRight: 8,
    fontSize: 9,
    textAlign: "right",
  },

  // Totals section
  totalsSection: {
    marginTop: 15,
    flexDirection: "column",
    alignItems: "flex-end",
    width: "100%",
    paddingRight: 20,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: 200,
    marginBottom: 5,
    paddingVertical: 3,
  },
  totalLabel: {
    fontSize: 11,
    color: "#2c3e50",
    fontWeight: "bold",
  },
  totalValue: {
    fontSize: 11,
    color: "#2c3e50",
    fontWeight: "bold",
  },
  grandTotalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: 200,
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 2,
    borderTopColor: "#3498db",
  },
  grandTotalLabel: {
    fontSize: 13,
    color: "#2c3e50",
    fontWeight: "bold",
  },
  grandTotalValue: {
    fontSize: 13,
    color: "#e74c3c",
    fontWeight: "bold",
  },

  // Quote details section
  quoteDetails: {
    marginTop: 25,
    marginBottom: 15,
    backgroundColor: "#e8f5e8",
    padding: 15,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#27ae60",
  },
  quoteRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
    paddingVertical: 2,
  },
  quoteLabel: {
    fontWeight: "bold",
    fontSize: 10,
    color: "#27ae60",
  },
  quoteValue: {
    fontSize: 10,
    color: "#2c3e50",
    fontWeight: "bold",
  },

  // Footer section
  footerSection: {
    marginTop: 40,
    borderTopWidth: 2,
    borderTopColor: "#bdc3c7",
    paddingTop: 20,
    backgroundColor: "#f8f9fa",
    padding: 20,
    borderRadius: 8,
  },
  footerTitle: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 10,
    textTransform: "uppercase",
  },
  footerText: {
    fontSize: 9,
    color: "#34495e",
    marginBottom: 4,
    lineHeight: 1.3,
  },
  bankInfo: {
    marginTop: 15,
    backgroundColor: "#ffffff",
    padding: 12,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#dee2e6",
  },
  bankTitle: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
  },
  bankRow: {
    flexDirection: "row",
    marginBottom: 3,
  },
  bankLabel: {
    fontSize: 9,
    color: "#7f8c8d",
    width: 60,
  },
  bankValue: {
    fontSize: 9,
    color: "#2c3e50",
    fontWeight: "bold",
  },

  // Signature section
  signatureSection: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: "#dee2e6",
  },
  logo: {
    width: 100,
    height: 50,
  },
  signatureText: {
    fontSize: 9,
    color: "#7f8c8d",
    fontStyle: "italic",
  },
  pageNumber: {
    marginTop: 10,
    fontSize: 8,
    color: "#95a5a6",
    textAlign: "right",
  },

  // Utility classes
  bold: {
    fontWeight: "bold",
  },
  italic: {
    fontStyle: "italic",
  },
  textCenter: {
    textAlign: "center",
  },
  textRight: {
    textAlign: "right",
  },
  textLeft: {
    textAlign: "left",
  },
  marginTop: {
    marginTop: 10,
  },
  marginBottom: {
    marginBottom: 10,
  },
  padding: {
    padding: 10,
  },
  backgroundColor: {
    backgroundColor: "#f8f9fa",
  },
});
